// removed by extract-text-webpack-plugin
module.exports = {"root":"Embed__root--xU4tk","embedContainer":"Embed__embedContainer--2z7Wi","responsiveIframe":"Embed__responsiveIframe--2HKkM","fullBleed":"Embed__fullBleed--3XP5F","hide":"Embed__hide--ke6PL","bounce":"Embed__bounce--1Vb4r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Embed/Embed.css
// module id = ./src/components/Library/Embed/Embed.css
// module chunks = 1